<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>

        <rwidget-empty-state
            *ngIf="(loading$ | async) === false && (bookings$ | async)?.length === 0"
            [title]="'BOOKINGS_PAGE_TITLE'"
            [description]="'BOOKINGS_EMPTY_DESCRIPTION'">
            <a
                class="flex-center width-220 btn btn--primary btn--big link--no-line dark:text-contrast-black"
                [routerLink]="'/book-a-ride' | localize"
                tabindex="0">
                {{ 'HEADER_BOOK_RIDE' | translate }}
            </a>
        </rwidget-empty-state>

        <ridango-ui-basic-loading-spinner
            *ngIf="loading$ | async"
            [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
        </ridango-ui-basic-loading-spinner>

        <!-- Confirmed bookings -->
        <div
            class="card-detail-view-area-ticket"
            *ngIf="(loading$ | async) === false && (bookings$ | async).length > 0">
            <h1 class="page-title">{{ 'BOOKINGS_PAGE_TITLE' | translate }}</h1>
            <p>{{ 'BOOKINGS_PAGE_DESC' | translate }}</p>

            <div class="ticekts-active-state--label" *ngIf="(confirmedBookings$ | async).length > 0">
                {{ 'BOOKINGS_PAGE_LABEL_CONFIRMED_BOOKINGS' | translate }}
            </div>
            <div
                class="single-ticket"
                *ngFor="let booking of confirmedBookings$ | async | sort: 'starting_point_timestamp' : 'datestring'">
                <div class="single-ticket__content">
                    <div class="border-line"></div>
                    <div class="single-ticket__top-content">
                        <div class="single-ticket-left-content">
                            <div class="clearfix">
                                <div class="single-ticket-left-content__items">
                                    <span class="title">{{ 'TABLE_HEADER_PICK_UP' | translate }}</span>
                                    <span class="description">
                                        {{ booking.starting_point_timestamp | date: dateFormat }}
                                        <ng-container *ngIf="booking.priority_time === 'DEPARTURE'">
                                            ({{ 'TABLE_HEADER_PRIORITY' | translate }})</ng-container
                                        >
                                        <br />
                                        {{ booking.starting_point_address }}
                                    </span>
                                </div>
                                <div class="single-ticket-left-content__items clearfix">
                                    <span class="title">{{ 'TABLE_HEADER_DROP_OFF' | translate }}</span>
                                    <span class="description">
                                        {{ booking.destination_timestamp | date: dateFormat }}
                                        <ng-container *ngIf="booking.priority_time === 'ARRIVAL'">
                                            ({{ 'TABLE_HEADER_PRIORITY' | translate }})</ng-container
                                        >
                                        <br />
                                        {{ booking.destination_address }}
                                    </span>
                                </div>
                            </div>

                            <div class="single-ticket-left-content__items">
                                <!-- <span class="title">1’st stopover</span>
                                <span class="description">Riia maantee 20, Pärnu, 80013 Pärnu maakond</span> -->
                                <a class="link link--action link--emphasized" (click)="showBookingRoute(booking)">
                                    {{ 'BOOKINGS_PAGE_VIEW_ROUTE' | translate }}</a
                                >
                            </div>
                        </div>
                        <div class="single-ticket-right-content">
                            <div class="single-ticket-left-content__items full-width">
                                <span class="title">{{ 'TABLE_HEADER_VEHICLE' | translate }}</span>
                                <span class="description">{{ booking.location_reg_number }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="single-ticket-left-content remove-padding-margin-border">
                        <div class="clearfix">
                            <div class="single-ticket-left-content__items">
                                <span class="title">{{ 'PRICE' | translate }}</span>
                                <span class="secondary-description"
                                    >{{ booking.price | thousandsFormat }}
                                    {{ booking?.price?.currency || appStartupService.getCurrency() | translate }}</span
                                >
                            </div>
                            <div class="single-ticket-left-content__items">
                                <span class="title">
                                    <span class="inline-title">{{ 'TABLE_HEADER_PASSENGER' | translate }}</span>
                                </span>
                                <span class="inline-secondary-description">
                                    {{ booking.customer_name }}
                                    <ng-container *ngIf="booking.attendant_count && booking.attendant_count > 1"
                                        >(+{{ booking.attendant_count - 1 }})
                                    </ng-container>
                                </span>
                            </div>
                        </div>
                        <div class="single-ticket-left-content__items full-width" *ngIf="booking.web_client_comment">
                            <span class="title">{{ 'BOOKINGS_PAGE_LABEL_ADDITIONAL_INFO' | translate }}</span>
                            <span class="secondary-description">{{ booking.web_client_comment }}</span>
                        </div>
                    </div>
                </div>

                <div class="single-ticket-notification">
                    {{ 'BOOKINGS_PAGE_LABEL_CANCELLING_INFO_PHONE' | translate }}
                    <a
                        class="link link--no-line link--action"
                        href="tel:{{ 'BOOKINGS_PAGE_LABEL_CANCELLING_INFO_PHONE_' + env.REGION_ID | translate }}">
                        {{ 'BOOKINGS_PAGE_LABEL_CANCELLING_INFO_PHONE_' + env.REGION_ID | translate }}</a
                    >
                </div>
            </div>

            <!-- Pending bookings -->
            <div class="ticekts-active-state--accent" *ngIf="(pendingBookings$ | async).length > 0">
                {{ 'BOOKINGS_PAGE_LABEL_PENDING_BOOKINGS' | translate }}
            </div>
            <div
                class="single-ticket"
                *ngFor="let booking of pendingBookings$ | async | sort: 'starting_point_timestamp' : 'datestring'">
                <div class="single-ticket__content">
                    <div class="border-line accent"></div>
                    <div class="single-ticket__top-content">
                        <div class="single-ticket-left-content">
                            <div class="clearfix">
                                <div class="single-ticket-left-content__items">
                                    <span class="title">{{ 'TABLE_HEADER_PICK_UP' | translate }}</span>
                                    <span class="description">{{ booking.starting_point_address }}</span>
                                </div>
                                <div class="single-ticket-left-content__items clearfix">
                                    <span class="title">{{ 'TABLE_HEADER_DROP_OFF' | translate }}</span>
                                    <span class="description">{{ booking.destination_address }}</span>
                                </div>
                            </div>

                            <!-- <div class="single-ticket-left-content__items">-->
                            <!--     <span class="title">1’st stopover</span>-->
                            <!--     <span class="description">Riia maantee 20, Pärnu, 80013 Pärnu maakond</span>-->
                            <!-- </div>-->
                        </div>
                        <div class="single-ticket-right-content">
                            <div class="single-ticket-left-content__items full-width">
                                <span class="title">{{ 'TABLE_HEADER_PRIORITY' | translate }}</span>
                                <span class="description" *ngIf="booking.priority_time === 'DEPARTURE'"
                                    >{{ booking.starting_point_timestamp | date: dateFormat }} <br />
                                    ({{ 'RIDE_PICKUP_TIME' | translate }})</span
                                >
                                <span class="description" *ngIf="booking.priority_time === 'ARRIVAL'"
                                    >{{ booking.destination_timestamp | date: dateFormat }} <br />
                                    ({{ 'RIDE_DROPOFF_TIME' | translate }})</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="single-ticket-left-content remove-padding-margin-border">
                        <div class="clearfix">
                            <div class="single-ticket-left-content__items">
                                <span class="title">{{ 'TABLE_HEADER_EST_PRICE' | translate }}</span>
                                <span class="secondary-description" *ngIf="booking.price !== undefined">
                                    {{ booking.price | thousandsFormat }}
                                    {{ booking?.price?.currency || appStartupService.getCurrency() | translate }}</span
                                >
                                <span class="secondary-description" *ngIf="booking.price === undefined">{{
                                    'RIDE_WAITING_CONFIRMATION' | translate
                                }}</span>
                            </div>
                            <div class="single-ticket-left-content__items">
                                <span class="title">
                                    <span class="inline-title">{{ 'TABLE_HEADER_PASSENGER' | translate }}</span>
                                </span>
                                <span class="inline-secondary-description">
                                    {{ booking.customer_name }}
                                    <ng-container *ngIf="booking.attendant_count && booking.attendant_count > 1"
                                        >(+{{ booking.attendant_count - 1 }})
                                    </ng-container>
                                </span>
                            </div>
                        </div>
                        <div class="single-ticket-left-content__items full-width" *ngIf="booking.web_client_comment">
                            <span class="title">{{ 'BOOKINGS_PAGE_LABEL_ADDITIONAL_INFO' | translate }}</span>
                            <span class="secondary-description">{{ booking.web_client_comment }}</span>
                        </div>
                    </div>

                    <div class="single-ticket-right-content remove-padding-margin-border hide-mobile">
                        <div class="single-ticket-left-content__items delete-item">
                            <span (click)="showCancelModal(booking)">
                                <a class="link">
                                    <span>{{ 'BOOKINGS_PAGE_CTA_CANCEL_BOOKING' | translate }}</span>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #cancelConfirmationModal>
        <h1 class="dialog-title bold">
            {{ 'BOOKINGS_PAGE_MODAL_CANCEL_TITLE' | translate }}
        </h1>

        <div class="dialog-description">
            {{ 'BOOKINGS_PAGE_MODAL_CANCEL_DESC' | translate }}
        </div>
        <div class="dialog-buttons-area">
            <div class="dialog-buttons-area__right">
                <button
                    class="btn btn--big btn--primary btn--maximal"
                    (click)="cancelBooking()"
                    (keydown.space)="cancelBooking()"
                    (keydown.enter)="cancelBooking()"
                    tabindex="0">
                    {{ 'BOOKINGS_PAGE_MODAL_CANCEL_CONFIRM' | translate }}
                </button>
            </div>

            <div class="dialog-buttons-area__left">
                <a class="link link--emphasized link--action" tabindex="0" mat-dialog-close>
                    {{ 'BOOKINGS_PAGE_MODAL_CANCEL_CANCEL' | translate }}
                </a>
            </div>
        </div>
    </ng-template>

    <ng-template #bookingRouteModal>
        <div class="dialog-close-button" mat-dialog-close>✕</div>
        <div class="dialog-notification">
            {{ 'BOOKINGS_PAGE_MAP_INFO' | translate }}
        </div>

        <rwidget-map [latitude]="mapCenter.latitude" [longitude]="mapCenter.longitude" [hasControls]="false">
            <rwidget-map-layer-group [fit]="true">
                <rwidget-map-polyline *ngIf="ride" [encodedPath]="ride.shape_polyline" [color]="polylineColor">
                </rwidget-map-polyline>

                <rwidget-map-marker
                    *ngIf="rideStart"
                    [latitude]="rideStart[0]"
                    [longitude]="rideStart[1]"
                    [isSingle]="true">
                    <rwidget-map-icon [url]="iconOrigin" [size]="[18, 24]" [anchor]="[9, 24]"></rwidget-map-icon>
                </rwidget-map-marker>

                <rwidget-map-marker
                    *ngIf="rideStop"
                    [latitude]="rideStop[0]"
                    [longitude]="rideStop[1]"
                    [isSingle]="true">
                    <rwidget-map-icon [url]="iconDestination" [size]="[24, 24]"></rwidget-map-icon>
                </rwidget-map-marker>
            </rwidget-map-layer-group>

            <rwidget-map-layer-group>
                <rwidget-map-marker *ngFor="let bus of buses" [latitude]="bus.latitude" [longitude]="bus.longitude">
                    <rwidget-map-icon [anchor]="[17, 17]" [size]="[34, 34]">
                        <rwidget-map-bus-icon [bus]="bus"> </rwidget-map-bus-icon>
                    </rwidget-map-icon>
                </rwidget-map-marker>
            </rwidget-map-layer-group>
            <rwidget-map-locator></rwidget-map-locator>
        </rwidget-map>
    </ng-template>
</div>
